import React, { Fragment, ReactNode } from 'react';
import { styled, View } from 'dripsy';

import { Separator } from '../../common/Separator';

export enum DirectionCollageEnum {
  Row = 'row',
  Column = 'column',
}

interface IContainerProps {
  containerDirection?: DirectionCollageEnum;
}

const Container = styled(View)((props: IContainerProps) => ({
  flex: 1,
  flexDirection:
    props.containerDirection ?? DirectionCollageEnum.Column,
}));

export interface IDirectionCollageProps {
  children: ReactNode[];
  direction?: DirectionCollageEnum;
}

export function DirectionCollage({
  children,
  direction,
}: IDirectionCollageProps) {
  return (
    <Container containerDirection={direction}>
      {children.map((child, index) => {
        const isFirstChild = index === 0;
        const isVertical = direction === DirectionCollageEnum.Row;

        return (
          <Fragment key={index}>
            {!isFirstChild && (
              <Separator size="$4" vertical={isVertical} />
            )}
            {child}
          </Fragment>
        );
      })}
    </Container>
  );
}
